import React from 'react';
import { CHAT_STORE, ChatStore, RemetenteMensagem, PagedRequest } from '../../Store/Chat';
import {
  Card,
  CardTitle,
  CardActions,
  Button,
  CardContent,
  Modal,
  InputFile,
  Checkbox,
  Textarea,
  TextButton,
  TabComponent,
  TabPanel,
  TutorialButtonAndBackButton
} from '../../Components';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import Chat from '../../Components/Chat';
// import { apiState } from '../../Api';
import Tutorial_Aluno from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Aluno.pdf";

interface IProps extends RouteComponentProps {
  [CHAT_STORE]: ChatStore;
}

interface IState {
  isModalOpen: boolean;
  carregando: boolean;
}

const StyledCardActions = styled(CardActions) <any>`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 20px;
`
const StyledMesageInput = styled(Textarea) <any>`
  /* margin: 15px 0 -15px 2px; */
  flex-grow: 1;
`;

const StyledContainer = styled.div`
  padding: 10px 5px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const StyledButtons = styled.div`
  display: flex;
`;

@inject(CHAT_STORE)
@observer
export default class ChatPage extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      isModalOpen: false,
      carregando: false
    }
  }

  sendMessage = async () => {
    const store = this.props[CHAT_STORE];

    await store.sendMensagem(['aluno']).then(() => {
      store.getMensagens(['aluno'], true, new PagedRequest({ search: '', page: 1, pageSize: 10 }))
    });
  }

  onResumeClick = () => {
    window.open(Tutorial_Aluno);
  }

  handleChange = (dynamicArguments: ['anexo', File] | ['texto', string] | ['aluno', number]) => {
    const store = this.props[CHAT_STORE];

    store.updateMessageAttribute(dynamicArguments[0], dynamicArguments[1]);
  }

  componentDidMount() {
    const store = this.props[CHAT_STORE];
    store.getMensagens(['aluno']);

  }

  getMoreMessages = () => {
    const store = this.props[CHAT_STORE];

    store.getMensagens(['aluno'], true);
  }

  doDownload = (id: string) => {
    const store = this.props[CHAT_STORE];

    store.getAnexo(id);
  }

  render() {
    const { [CHAT_STORE]: chatStore } = { ...this.props };
    const {
      updateMessageAttribute,
      novaMensagem,
      mensagens,
      apiStates
    } = chatStore;
    const { history } = this.props;

    return (
      <>
        <TutorialButtonAndBackButton
          openTutorial={this.onResumeClick}
          voltar={() => history.push('/aluno')}
        />
        <Card>
          <CardTitle>Orientações do professor</CardTitle>
          <CardContent>
            <Chat
              usuario={RemetenteMensagem.aluno}
              mensagens={mensagens}
              carregando={apiStates.getMensagensState}
              carregarMais={() => { this.getMoreMessages(); }}
              doDownload={this.doDownload}
            />
          </CardContent>
          <StyledCardActions>
            <StyledContainer>
              <StyledMesageInput
                value={novaMensagem.texto || ''}
                type='text'
                label='Mensagem'
                onChange={(e: any) => { updateMessageAttribute('texto', e.target.value) }}
              />
              <Checkbox
                label='Marque aqui, se deseja que o orientador seja notificado dessa mensagem por e-mail'
                checked={Boolean(novaMensagem.enviarEmail)}
                onChange={(e: any) => { updateMessageAttribute('enviarEmail', e.target.checked) }}
              />
            </StyledContainer>
            <StyledButtons>
              <TextButton onClick={() => this.setState({ isModalOpen: true })}>
                <img width="20px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAA00lEQVRIie2VTQrCMBCFP1y48ga16sYTiDfQK6pXkOLGulBPY90LWleKUBd9wVot2DSCSB+EwEzyvWHID/yA2kAAxBoLoO8SfgCS3DgAnguDQMBQQA9YKTZ3YRALlq3WV+zowsC05NP4ixrfNitjYKXaoDb4M4OrZvOSXlwUkL2lW55f1PWbNaV10+Ym0AE2wFlwX/FE66y0F2BQkB8qv7M1mAmwLMiHyk9sDXo8/oSQtOKWZgM/kbbPWmNB8t+mgY+qwI26wBSISI9nRNqWSpU70R2qYEYBWs09wgAAAABJRU5ErkJggg=="/>
              </TextButton>
              <Button onClick={this.sendMessage}>Enviar</Button>
            </StyledButtons>
          </StyledCardActions>
        </Card>
        <Modal
          isVisible={this.state.isModalOpen}
          outterClick={() => this.setState({ isModalOpen: false })}
          size={'small'}
        >
          <TabComponent activeChild='Arquivo'>
            <TabPanel titulo={'Arquivo'}>
              <Card>
                <CardContent
                  style={{ marginTop: '10px', marginBottom: '-10px' }}
                >
                  <InputFile
                    label={'Anexe aqui seu arquivo'}
                    width={'100%'}
                    accept='application/pdf'
                    onChange={(e) => this.handleChange(['anexo', e.target.files[0]])}
                  />
                </CardContent>
                <StyledCardActions>

                  <StyledMesageInput
                    value={novaMensagem.texto || ''}
                    type='text'
                    label='Mensagem'
                    onChange={(e: any) => this.handleChange(['texto', e.target.value])}
                  />
                  <StyledButtons>
                    <Button onClick={() => {
                      this.sendMessage();
                      this.setState({ isModalOpen: false });
                    }}>Enviar</Button>
                  </StyledButtons>
                </StyledCardActions>
              </Card>
            </TabPanel>
          </TabComponent>
        </Modal>
      </>
    )
  }
}